export default "__VITE_ASSET__BHlqTQNs__"